import { renderPDF, renderEMAIL } from './useTemplateExtras';

export const renderTemplate = (type, templateEditModel, options = {}) => {
    if (type === 'PDF') {
        return renderPDF(templateEditModel, options);
    }

    if (type === 'EMAIL') {
        return renderEMAIL(templateEditModel);
    }
    return '';
};

export const useTemplateRenderer = () => {
    return {
        renderTemplate: renderTemplate,
    };
};

export default useTemplateRenderer;
